import React from "react";
import { Link } from "gatsby";
import MobileMenu from './MobileMenu';
import logo from "../../images/logo.png";

const styles = {
  marginTop: '50px', 
  padding: "15px 0"
}

const Header = () => {

  return(
    <header className="header header--bottom" style= { styles }>
      <div className="container">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <Link to="/" className="d-flex align-items-center"> 
              <img src={ logo } alt="Green" style={{ height: "35px", marginRight:"10px" }} />
              <span className="logo-text">garden</span>
            </Link>
          </div>
          <MobileMenu />
          <div className="nav-menu-wrap">
            <ul className="nav-menu">
              <li className="nav-menu__list">
                <Link to="/balcony-garden" className="nav-menu__link">
                  balcony garden
                </Link>
              </li>
              <li className="nav-menu__list">
                <Link to="/artificial-grass" className="nav-menu__link">
                  artificial grass
                </Link>
              </li>
              <li className="nav-menu__list">
                <Link to="/vertical-garden" className="nav-menu__link">
                  vertical garden
                </Link>
              </li>
              <li className="nav-menu__list">
                <Link to="/landscaping" className="nav-menu__link">
                  landscaping 
                </Link>
              </li>
              <li className="nav-menu__list">
                <Link to="/terrace-garden" className="nav-menu__link">
                  terrace garden 
                </Link>
              </li>
              <li className="nav-menu__list">
                <a href="/consultation" className="nav-menu__link">
                  customize
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
}


export default Header;